/* Verified against Shopify's active rules on 2026-09-28. Amounts in grosze.
   BxGy: one 60 PLN discount OR cheapest floor(n/3) free; 80 PLN order discount
   starts at 387 PLN AFTER product discounts. Never quote unsupported carts. */
(function (root) {
  function total(items) {
    const prices = [];
    for (const item of items) {
      if (!item.eligible || !Number.isInteger(item.quantity) || item.quantity < 1 ||
          !Number.isInteger(item.price) || item.price < 6000) return null;
      for (let i = 0; i < item.quantity; i++) prices.push(item.price);
    }
    if (!prices.length || prices.length > 12) return null;
    prices.sort((a, b) => a - b);
    const sum = prices.reduce((a, b) => a + b, 0);
    const free = prices.slice(0, Math.floor(prices.length / 3)).reduce((a, b) => a + b, 0);
    const net = sum - Math.max(prices.length >= 2 ? 6000 : 0, free);
    return net >= 38700 ? net - 8000 : net;
  }
  function quote(cart, price) {
    if (!cart || cart.currency !== 'PLN' || cart.has_code || total(cart.items) !== cart.total_price) return null;
    const next = total([...cart.items, { price, quantity: 1, eligible: true }]);
    if (next === null || next < cart.total_price) return null;
    return { delta: next - cart.total_price, total: next };
  }
  const api = { total, quote };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.SPCartPricing = api;
})(typeof window !== 'undefined' ? window : globalThis);
